import React from 'react';
import PropTypes from "prop-types";
import { Form } from "reactstrap";
import { reduxForm } from "redux-form";
import { connect } from "react-redux";
import Loader from "../../../common/Loader";
import FormFooter from "../../../common/forms/FormFooter";
import DocumentTypeFormFields from './DocumentTypeFormField';

export const DocumentTypeForm = ({
  handleSubmit,
  loading,
  initialValues,
}) => {
  if (loading) return <Loader />;

  return (
    <Form onSubmit={handleSubmit}>
      <DocumentTypeFormFields
        initialValues={initialValues}
      />
      <FormFooter />
    </Form>
  );
};

DocumentTypeForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
  initialValues: PropTypes.shape({}),
};

DocumentTypeForm.defaultProps = {
  initialValues: null,
};

const mapStateToProps = (state) => ({
  loading: !state.BusUnit.DocumentType.getIn([
    'current',
    'activity',
  ]).isEmpty(),
});

const formComponent = reduxForm({
  form: 'DocumentTypeForm',
})(DocumentTypeForm);

export default connect(mapStateToProps)(formComponent);